<template>
  <div v-if="loaded && channels.length === 0" class="card card-custom gutter-b">
    <div class="card-body">
      <!--begin::Heading-->
      <div class="card-px text-center pt-15 pb-15">
        <!--begin::Title-->
        <h2 class="fs-2x fw-bold mb-0">
          به رسانه‌‌ی میرول خوش آمدید.
        </h2>
        <!--end::Title-->
        <!--begin::Description-->
        <p class="text-gray-400 fs-4 fw-semibold py-7">
          با افزودن برنامه‌های خود به کانال خود میتوانید کانال شخصی خود را داشته
          داشته باشید.
        </p>
        <!--end::Description-->

        <!--begin::Action-->
        <router-link
          :to="{ name: 'channels-create' }"
          class="btn btn-primary er fs-6 px-8 py-4"
        >
          افزودن کانال
        </router-link>
      </div>
      <!--end::Heading-->
      <!--begin::Illustration-->
      <div class="text-center pb-15 px-5">
        <img
          src="/media/svg/illustrations/working.svg"
          alt=""
          class="mw-100 h-200px h-sm-325px"
        />
      </div>
      <!--end::Illustration-->
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import { mapGetters } from "vuex";
import { FETCH_CHANNELS } from "@/core/services/store/channels.module";

export default {
  name: "channels",
  data() {
    return {
      loaded: false
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "رسانه من" }]);

    this.$store.dispatch(SET_ACTIONS, {});

    if (this.channel && this.channel.id) {
      this.$router.push({
        name: "channels-show",
        params: { id: this.channel.id }
      });
    } else {
      this.getChannels();
    }
  },
  computed: {
    ...mapGetters(["channels", "channel"])
  },
  methods: {
    getChannels() {
      this.loaded = false;
      this.$store
        .dispatch(FETCH_CHANNELS)
        .then(() => {
          this.loaded = true;

          if (this.channels && this.channels[0].id) {
            this.$router.push({
              name: "channels-show",
              params: { id: this.channels[0].id }
            });
          }
        })
        .catch(() => {
          this.loaded = true;
        });
    }
  }
};
</script>
